import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl } from "@angular/forms";
import { ObjectUtils } from '@cv-invision/core';
import { FieldModel, GenericFormService } from "@cv-invision/cv.invision-views.ux";

@Component({
	selector: 'cv-array-field',
	templateUrl: './array-field.component.html',
	styleUrls: [ './array-field.component.scss' ],
})
export class ArrayFieldComponent implements OnInit {

	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	options: any;
	arrayChilds: any;

	constructor(
		private genericFormService: GenericFormService
	) {
	}

	ngOnInit(): void {
		this.options = this.field.options;
		this.arrayChilds = [];
		if (this.value.length) {
			let index = 0;
			for (const child of this.value) {
				const formBuilderconfig = this.addFormArray({createFormControls: false, value: child});

				for (const keyChild in formBuilderconfig) {
					const value = (this.genericFormService.form.get(this.field.path) as FormArray)?.at(index)?.get(keyChild)?.value;

					if ('UIEvents' in formBuilderconfig[keyChild] && formBuilderconfig[keyChild].UIEvents.onChange && value != '') {
						const fieldData = {
							index: index,
							childKey: keyChild,
							key: this.field.Name,
							path: this.field.path,
						}
						formBuilderconfig[keyChild].UIEvents.onChange(
							{ value: value }, this.genericFormService.formFieldList, this.genericFormService.form, this.field.extraData, fieldData);
					}
				}

				index++;
			}
		}
	}


	public addFormArray($event): any {
		const child = [];
		const formBuilderChild = {};
		const formBuilderConfig = this.field;
		const formBuilderConfigChild = ObjectUtils.recursiveDeepCopy(formBuilderConfig[ 'childFormBuilderConfig' ]);

		for (const key in formBuilderConfigChild) {
			const childField: any = {
				key: key,
				path: this.field.path,
				hidden: formBuilderConfigChild[ key ].hidden === undefined ? false : formBuilderConfigChild[ key ].hidden,
			}
			child.push(childField);
			formBuilderChild[ key ] = $event.value ? $event.value[ key ] : null;

			if ('defaultValue' in formBuilderConfigChild[ key ]) {
				formBuilderChild[ key ] = formBuilderConfigChild[ key ][ 'defaultValue' ];
			}
			if('disabled' in this.field){
				formBuilderConfigChild[ key ][ 'disabled' ] = this.field.disabled;
			}
		}
		this.arrayChilds.push(child);
		formBuilderConfig.child.push(formBuilderConfigChild);

		if ($event.createFormControls) {
			this.genericFormService.createChilds(this.field.path, formBuilderChild);
		}
		return formBuilderConfigChild;
	}

	public deleteRowFormArray($event): void {
		const index = $event.index;
		this.arrayChilds.splice(index, 1);
		const formArray = this.genericFormService.form.get(this.field.path) as FormArray;
		this.field.child.splice(index, 1);
		formArray.removeAt(index);
		this.control.updateValueAndValidity();
	}

}
